import { render } from "./ListaView.vue?vue&type=template&id=c7d571a4&ts=true"
import script from "./ListaView.vue?vue&type=script&lang=ts"
export * from "./ListaView.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__